module.exports = __webpack_public_path__ + "img/Logo_Area_Completo_negro.63bd8104.png";